// extracted by mini-css-extract-plugin
export default {"cls1":"JTeBMG5XGnSIE1l5nJXZ","cls2":"TJW1RbCsVBE8P3UnyVIc JTeBMG5XGnSIE1l5nJXZ","progress-lighting":"Ak1RdPmAi6g3RJGTCBK1"};